import type { ClassValue } from 'class-variance-authority/types';
import Title from '~/components/utils/Title';
import { cn } from '~/utils';

const BORDER = 'border-b border-blue-200';

const BizzLayout = {
    Header: (props: {
        children?: React.ReactNode;
        title?: React.ReactNode;
        className?: ClassValue;
        'data-testid'?: string;
    }) => (
        <header
            data-testid={props['data-testid']}
            className={cn(
                'flex flex-col gap-9 bg-foreground px-6 pb-8 pt-12 sm:p-15',
                BORDER,
                props.className,
            )}
        >
            {
                // prettier-ignore
                props.title && (typeof props.title === 'string' 
                    ? <Title size="3xl" className='max-lg:text-center max-lg:text-2xl!'>{props.title}</Title> 
                    : props.title
                )
            }
            {props.children}
        </header>
    ),

    Section: (props: {
        id?: string;
        children?: React.ReactNode;
        className?: ClassValue;
        style?: React.CSSProperties;
        /** @default 'main' */
        as?: 'main' | 'section' | 'div';
        'data-testid'?: string;
    }) => {
        const Component = props.as ?? 'main';

        return (
            <Component
                id={props.id}
                data-testid={props['data-testid']}
                className={cn('px-6 py-10 md:px-15 md:py-10 lg:py-15', props.className)}
                style={props.style}
            >
                {props.children}
            </Component>
        );
    },
};

export default BizzLayout;
